module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter-no",
    attrs: {
      "id": "ch-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("1")])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“Y"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OU KNOW")]), _vm._v(" that one of our passengers is wanted for murder, don’t you, sir?” said Appleyard the Chief Mate of the "), _c('em', [_vm._v("Saragossa.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Captain Bidlake gave him an unfriendly, one might almost say a dirty, look.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Don’t exaggerate,” he said curtly. “Haven’t I enough troubles on this trip, without you making matters worse than they are? All the newspapers said was that the police would like to make some enquiries from this Larkin which they think might assist them in their investigations. That doesn’t mean he’s wanted for murder.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Nine times out of ten, it does. It’s Contempt of Court if they say any more.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Captain Bidlake was normally a good-humoured man, though rather unimaginative, but the events of the last few days had tried his temper too far.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Don’t lecture me about Contempt of Court,” he snapped.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“No, sir,” said Appleyard, surprised and apologetic. “It’s awkward having the fellow on board at all, though, isn’t it? The other passengers are most uncomfortable about it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The "), _c('em', [_vm._v("Saragossa")]), _vm._v(" was a cargo-boat which ran between London and the Spanish and North African ports and was now on her way home from Tangier. She carried half a dozen passengers, who had their meals in the saloon with the officers and spent their days on a few square feet of deck space.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I don’t wonder,” said Captain Bidlake more mildly. “I’m uncomfortable about it myself. Suppose the fellow "), _c('em', [_vm._v("has")]), _vm._v(" committed a murder? How do we know he won’t do it again? I want nothing of that kind on my ship, Appleyard.”")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("Of course you don’t, you old fool, thought Appleyard.")])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“No, sir,” he said aloud, as though he had been given an order to prevent a murder on the "), _c('em', [_vm._v("Saragossa")]), _vm._v(" and had accepted it. “The man’s such an awkward customer in any case. Contentious and rude. And I don’t think I’ve ever heard such a voice in my life.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Loud, isn’t it?” said the Captain sadly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Loud, sir? It’s deafening. He shouts the whole time. At everyone. At first when I heard him speaking to the steward I thought he had lost his temper. But it’s his natural voice. He had an argument with Mr Prosper today …”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Which is that?” asked the Captain, who spent as little time as possible among his passengers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“That tall, long-faced chap. Whisky salesman, I believe. Doesn’t speak much at all, but he can’t stand this Larkin, with his braying voice and his opinions. He asked him for heaven’s sake to keep quiet for a while. That was in the saloon this morning. Larkin nearly did his top. Quite threatening he got, too. Then yesterday he was rude to Mrs Roper.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Was he really?” asked the Captain incredulously.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Yes, sir. I should have thought he was asking for it. You know what an athletic woman she is. She could throw him across the saloon. She didn’t say much, but you could see the contempt she felt. I’m not surprised that the police want the fellow.” Appleyard thought he might risk a little joke. “As a matter of fact, if there were to be a murder on the ship I should guess Larkin would be on the receiving end.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Well, there’s not. We’ve got to get this fellow to London, where I’ve no doubt the police will be waiting for him. I’ve informed the owners that we have him on board, and they will do what’s proper. But it’s a most unpleasant situation. I can’t think what the agents were doing to let him book.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“They should have known. He has lived in Tangier for some years, apparently.”")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("“I know. What about the other passengers?”")])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“These two types, Butt and Ferry, are drunk most of the time. Nice quiet trip this, I must say, sir. But we shall land them all right in the end. We always do.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Yes. Have a drink, Appleyard?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Thank you, sir. Here’s to a quieter trip next time. No more murderers, anyway.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("This time the Captain did not bother to correct his description of Wilbury Larkin.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("There were a good many people in the world who would have endorsed it, anyway. The recent murder in England of a rich man named Gregory Willick was not one of the most-discussed crimes of the moment, and none of its suspects had appeared on television, but it had been given its decent-sized headlines for a day or two. It seemed, moreover, a fairly open-and-shut affair. Willick was a man of habit and took his dog out almost every day at the same time. He had been found shot on a woodland path on his own grounds at a place he passed as regularly as clockwork. No weapon was found near him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("All the facts as known to the investigating police were not, of course, published, but it was fairly obvious that their suspicions fell on Wilbury Larkin, who had arrived from Tangier a few days earlier, stayed at the local hotel the night before and had flown back to Tangier before the body was discovered.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("It was only after he had come aboard the "), _c('em', [_vm._v("Saragossa,")]), _vm._v(" having booked his passage home again, that a newsvendor had brought some English papers on board in which the Captain had been horrified to read that the police wanted to interview one of his passengers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“What I don’t understand,” said Appleyard after he had sipped his whisky and soda, “is why the fellow is going back to England. If he killed Willick and made a bolt for it the same night and got safely to Tangier why should he put his head in a noose?”")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("“Beating an extradition order, I suppose,” said Captain Bidlake disgustedly. “But why did he have to choose my ship?”")])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“It’s lucky we’ve got a fairly tough lot of passengers,” reflected Appleyard. “If we had any nervous old ladies on board it would be the end. The atmosphere in the saloon sometimes is positively murderous. I feel quite jumpy myself.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“In what way?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Hard to explain, sir. Larkin himself, for one thing. There’s something very odd about that man. Something that gives you the creeps.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Really, Appleyard, you’re talking absurdly. Just explain exactly what you mean, please.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I don’t think I can, sir. It’s something you feel. Everything’s too big about him, his voice, his great massive chest and shoulders, his eyes when you see them through those thick glasses of his, which seem to magnify them….”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Why should that give you the creeps, as you put it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Captain Bidlake was a literal-minded man who hated loose expressions and vague descriptions.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I don’t know. It’s something unnatural, something not quite human about him. And the clothes he wears …”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Old-fashioned, aren’t they?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I didn’t know you could still buy those tall starched collars. Who would want to, in this climate, anyway? Yet he never wears anything else, apparently. He has been seen about Tangier dressed like that on the hottest day. But there he had the reputation of a recluse. Scarcely spoke to anyone. Here he talks too much. That deafening voice of his goes on the whole time.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I still don’t understand what’s uncanny about him. I think you’ve got this idea of murder into your head and it makes you imagine things.”")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("“I’m not a fanciful man, sir. I pride myself on being down-to-earth and sensible about things like this. But you ")]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("don’t need to have much insight to see that there’s something very wrong down there. Something very wrong indeed. Even Kutz doesn’t like it.”")])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Kutz was the Second Officer, a displaced person from central Europe, a fine seaman who lived a solitary life on board. He was always polite to his fellow officers and the passengers and punctilious in his duties, but he spoke no more than necessary and there was something remote and tragic in his expression, his speech and his character.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“How do you know that?” asked the Captain, pouring out two more drinks. “Surely he hasn’t started unburdening himself?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Extraordinary thing, but he did speak to me quite confidentially about this. For him, I mean. He said suddenly last night, ‘I don’t like that man.’ I didn’t need to ask which.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“That "), _c('em', [_vm._v("is")]), _vm._v(" rather strange,” said Captain Bidlake, impressed at last. “Well, all we can do is to watch out. Keep an eye on them all. Don’t leave them alone too much.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("All very well, thought Appleyard, but what could you do against anything so indefinite? What was he to watch out for?")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The worst of it was they were all so close together. Passengers could only be in their cabins, in the little saloon or on the very small piece of deck. They could scarcely escape from one another for an hour at a time during the day. So that the man suspected of murder, Wilbury Larkin, the two enthusiastic drinkers Jerry Butt and Ronald Ferry, the tall gaunt Gerard Prosper with his perpetual pipe, and the Junoesque deep-voiced woman Mrs Roper, were for ever running into one another and could not have avoided conversation if they wished. Moreover the Captain, Mr Apple-yard himself and Kutz were frequently drawn in.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("Nothing, so far, had been said openly of murder. Clearly it was in everyone’s mind, for all on board had read the news which related to Wilbury Larkin. Doubtless the other ")]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("passengers had secretly discussed it, but much though they disliked the bombastic Larkin they had said nothing to show him that they were aware of his predicament.")])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("But on the night after Appleyard’s conversation with Captain Bidlake an extraordinary thing took place. Larkin, without warning and apparently without reason, began to discuss the matter himself. It was at dinner, in a pause in the conversation, that he suddenly said in his booming voice, “So you all think I’m a murderer, do you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("To this extraordinary question he seemed to expect a reply, for he remained quite silent. Gunner, the steward, who was handing round vegetables, stood gaping while his dish stayed at Mrs Roper’s elbow. The Captain pointedly went on eating.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I know what you’ve been saying among yourselves. You’ve seen the papers and you’ve quite made up your minds that I killed Gregory Willick. I suppose it gives you a sort of thrill to be in on the ground floor of a murder case, to be travelling with Suspect Number One. Something to tell your friends at home. Well, I’m sorry to disappoint you but you’re not going to have the pleasure, because I happen not to have done it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I don’t think anyone much wishes to discuss this,” said Gerard Prosper.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Well, I do,” shouted Larkin. “What’s more I’m dam’ well going to. If I’m as guilty as you think I am, why do you suppose I’m going home? It hasn’t occurred to you to ask that. Would a man who has killed another and got out safely to Tangier book his passage home as soon as he sees that the police ‘think he might help their enquiries’? It’s ridiculous.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Suddenly Mrs Roper, who could make her voice almost as strident as Larkin’s, deliberately addressed Gerard Prosper across the table.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Sun-bathing today?” she asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“For a little while,” said Prosper. “It’s rather windy, though.”")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("“Getting too near home.”")])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("This failed to suppress Larkin. He fixed his eye on the unfocusing eye of Jerry Butt and continued:")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“As a matter of fact, I liked old Gregory Willick. He was a good sort. Nothing stuck-up about him. Nothing mean. I can’t see what possible motive I’m supposed to have had. The evidence is scarcely even circumstantial. I was staying near his place at the time. That’s about all they’ve got. It seems I left to return to Tangier, where I live, on the very evening that the old boy was shot. What’s funny about that?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Gerard Prosper could suppress himself no longer.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Nothing,” he said. “Nothing is even remotely humorous about you or your entire conversation. If only there were. You’re a bore, Larkin. That’s worse than being a murderer. Now for God’s sake eat your dinner and allow us to eat ours.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("This really did shatter Larkin for a moment, and Mrs Roper seized her opportunity again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Making good time?” she asked the Captain. She clipped her sentences to the minimum and spoke in a fine hearty voice.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Quite,” said Captain Bidlake. “We ought to be in the Thames on Thursday night.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Appleyard found himself examining Larkin with some interest. The man was clearly purple with rage but could think of no adequate or quick retaliation. He was a big, bear-like fellow with a stoop. He had thick greying hair which was parted in the middle in an old-fashioned manner. His forehead was not broad but his face seemed to widen out as it descended, and when he grinned he showed massive teeth. But the oddest thing about him was his dress: dark-coloured suits and high starched collars, a watch-chain and several rings. He was champing now like an infuriated bull.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“If you talk to me like that, Prosper,” he said at last, “I shall …”")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("“Gentlemen,” cut in Captain Bidlake, “I’ll have no threats on my ship. Mr Larkin, I would ask you kindly not to discuss the matter you have raised this evening.”")])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("That produced silence. Even Mrs Roper held her peace. It was not for nearly a minute that anyone spoke and then Captain Bidlake gave an order to Gunner. But the situation remained electric.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Larkin now addressed the Captain. He appeared to have been thinking over what had been said to him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Why not?” he asked. “Why shouldn’t I discuss it? It’s in everybody’s mind. Why not let it be ventilated?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Bidlake was obviously miserable. He was a peace-loving man, a good seaman and a popular skipper, but he was not equipped to deal with a situation like this.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“It leads to dissension,” he said rather feebly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“It leads to damned impudence from Prosper, but so do other topics. As a matter of fact, all I was going to say is that I had not even the usual motive. If Willick left me any money it was certainly no more than a small sum. I …”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Gerard Prosper rose and without a word left the saloon. The steward had now cleared the table and Mrs Roper loudly suggested Bridge.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Make a four?” she asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("But Kutz had duties and the Captain excused himself. Seeing that she was in danger of being left alone with Larkin and Jerry Butt and Ronald Ferry, who had just ordered whisky-and-soda, she turned to Appleyard.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Play anything?” she asked rather ambiguously.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Appleyard liked her and understood her manner of speech.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Chess?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Splendid.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Even as they were setting out the pieces, Larkin boomed on:")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("“As a matter of fact I’d like to know where old Gregory’s money does go. Not much of it to Lance Willick, I’ll bet. ")]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("That’s his nephew who lives in Tangier. Great friend of mine.”")])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“You have a friend, then?” said Mrs Roper, looking up from the chessboard.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“What d’you mean?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Surprising,” said Mrs Roper and moved one of her pawns.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10bdd1c4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/004_Chapter01.vue
// module id = 69
// module chunks = 0